import { Box } from '@mui/material';
import HeaderNotifications from './Notifications';
import HeaderLanguage from './Language';

function HeaderButtons() {
  return (
    // En ligne et sans retour à la ligne : sur un écran étroit, le drapeau passait au-dessus
    // de la cloche.
    <Box sx={{ mr: { xs: 0, sm: 1 }, display: 'flex', alignItems: 'center', flexShrink: 0, whiteSpace: 'nowrap' }}>
      <Box sx={{ mx: 0.5 }} component="span">
        <HeaderLanguage />
      </Box>
      <Box sx={{ mx: 0.5 }} component="span">
        <HeaderNotifications />
      </Box>
    </Box>
  );
}

export default HeaderButtons;
